import React from 'react'

const StudentsAdmission = () => {
  return (
    <div>StudentsAdmission</div>
  )
}

export default StudentsAdmission